import { useState } from "react";
import { Scale } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "./ui/dialog";

const STROKE = 1.5;

export default function ComplianceDisclaimer() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 text-[12px] text-ink-500 hover:text-emerald-800 underline-offset-2 hover:underline"
        data-testid="compliance-disclaimer-link"
      >
        <Scale className="h-3 w-3" strokeWidth={STROKE} />
        Why this summary never judges tone, confidence, or fit
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl" data-testid="compliance-disclaimer-modal">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-medium">
              We summarise what was said. Not how it was said.
            </DialogTitle>
            <DialogDescription className="text-[13px] text-ink-500">
              A deliberate design choice — and a legal one.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-5 py-2 text-[14px] leading-relaxed text-ink-700">
            <p>
              Other interview tools advertise &ldquo;confidence scores,&rdquo; &ldquo;sentiment analysis,&rdquo; or &ldquo;cultural fit
              ratings&rdquo; derived from a candidate&rsquo;s voice. We don&rsquo;t produce any of those, by design. Hiretape
              summaries are built strictly from the verbal content of the conversation.
            </p>
            <div>
              <div className="hp-section-label">Why</div>
              <ul className="mt-2 space-y-2.5 list-disc list-inside">
                <li>
                  <span className="font-medium text-ink-900">U.S. EEOC enforcement guidance (2023):</span> AI tools used in
                  hiring that produce judgments correlated with protected characteristics — including voice-based affect
                  detection — create disparate-impact liability for the employer, not the vendor.
                </li>
                <li>
                  <span className="font-medium text-ink-900">EU AI Act (Annex III, in force 2026):</span> emotion-recognition
                  systems used in employment are classified high-risk. Avoiding them avoids the documentation, registration,
                  and conformity-assessment burden entirely.
                </li>
                <li>
                  <span className="font-medium text-ink-900">NYC Local Law 144:</span> automated employment decision tools
                  require an annual bias audit. We don&rsquo;t produce a decision tool — we produce a record. Different category,
                  no audit obligation triggered on you.
                </li>
              </ul>
            </div>
            <div>
              <div className="hp-section-label">What we do instead</div>
              <p className="mt-2">
                We surface the candidate&rsquo;s actual words: what projects they described, what they said about each competency,
                their notable quotes, the open questions worth raising next round. Hiring managers and interviewers decide what
                that means &mdash; not the model.
              </p>
            </div>
            <p className="text-[12px] text-ink-400 pt-2 border-t border-ink-200">
              This is informational and not legal advice. Always consult your employment counsel for your specific jurisdiction
              and use case.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
